import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 29.6rem;

  background: #ffffff;
  border-radius: 4.2339px;
`;

export const Icon = styled.div`
  position: absolute;
  top: 2rem;
  left: 2rem;
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 1.125rem;
  right: 0.9375rem;
  cursor: pointer;

  svg {
    width: 0.75rem;
    height: 0.75rem;
    &:hover {
      path,
      rect {
        stroke: #40e5a0;
      }
    }
  }
`;

export const Title = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 1.21rem;
  line-height: 1.524rem;

  margin-top: 2.08rem;
  width: 21.1rem;

  color: #000000;
`;

export const SubTitle = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.8rem;
  line-height: 1rem;

  margin-top: 1rem;
  width: 25.5rem;

  color: #585e66;
`;

export const InputContainer = styled.div`
  margin-top: 2rem;
  width: 25.5rem;
`;

export const ChoiceText = styled.span`
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;

  margin-top: 2rem;
  width: 25.5rem;

  color: #585e66;
`;

export const Togle = styled.div`
  width: 25.5rem;
  height: 2.69rem;
  margin-top: 1rem;
  display: flex;
`;

export const TogleGerente = styled.span`
  width: 12.75rem;
  height: 2.69rem;

  background: ${({ newUserCargo }) =>
    newUserCargo !== "colaborador" ? `#40e5a0` : `#FFfffF`};
  border: ${({ newUserCargo }) =>
    newUserCargo !== "colaborador"
      ? `1.4113px solid #40e5a0`
      : `0.07rem solid #d4d6da`};

  box-sizing: border-box;
  border-radius: 8.46781px 0px 0px 8.46781px;

  font-family: "Sora";
  font-style: normal;
  font-weight: ${({ newUserCargo }) =>
    newUserCargo !== "colaborador" ? `600` : `400`};
  font-size: 0.8rem;
  line-height: 1rem;

  color: #42464c;
  text-align: center;
  padding-top: 0.8rem;
  cursor: pointer;
`;

export const TogleColaborador = styled.div`
  width: 12.75rem;

  background: ${({ newUserCargo }) =>
    newUserCargo === "colaborador" ? `#40e5a0` : `#FFfffF`};
  border: ${({ newUserCargo }) =>
    newUserCargo ? `1.4113px solid #40e5a0` : `0.07rem solid #d4d6da`};
  box-sizing: border-box;
  border-radius: 0px 8.46781px 8.46781px 0px;

  font-family: "Sora";
  font-style: normal;
  font-weight: ${({ newUserCargo }) => (newUserCargo ? `600` : `400`)};
  font-size: 0.8rem;
  line-height: 1rem;

  color: #42464c;
  text-align: center;
  padding-top: 0.8rem;
  cursor: pointer; // timer
`;

export const StaticColab = styled.span`
  width: 12.75rem;

  background: #40e5a0;
  box-sizing: border-box;
  border-radius: 8.46781px;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.8rem;
  line-height: 1rem;

  color: #42464c;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem;
`;

export const Footer = styled.div`
  width: 25.5rem;
  margin-top: 3rem;
  display: flex;
  justify-content: flex-end;
`;
